/**
 * What: One-shot TestFeed-connected banner state keyed off the `testfeed_connected` return flag.
 * Transport / data-flow: Browser URL flag in, dismiss action out; strips the flag via replaceState.
 *
 */
import { useCallback, useState } from 'react'

export function hasConnectedFlag(search: string): boolean {
  return new URLSearchParams(search).get('testfeed_connected') === '1'
}

export function stripConnectedFlagFromUrl(): void {
  if (typeof window === 'undefined') return
  const url = new URL(window.location.href)
  if (!url.searchParams.has('testfeed_connected')) return
  url.searchParams.delete('testfeed_connected')
  window.history.replaceState(null, '', `${url.pathname}${url.search}${url.hash}`)
}

/** Shows the banner once on the connect return; dismiss hides it and clears the flag. */
export function useConnectedBanner(getSearch: () => string) {
  const [dismissed, setDismissed] = useState(false)
  const show = !dismissed && hasConnectedFlag(getSearch())
  const dismiss = useCallback(() => {
    stripConnectedFlagFromUrl()
    setDismissed(true)
  }, [])
  return { show, dismiss }
}
